import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 24px;
  .loadingRoot {
    width: 100%;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .payment-header {
    margin-bottom: 24px;
    span {
      font-weight: 700;
      font-size: 18px;
      line-height: 28px;
      color: #212b36;
    }
    .main-divider {
      height: 1px;
      background: #b1bbc7;
      position: relative;
      top: -16px;
    }
  }
  .payment-product-image {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    img {
      width: 100%;
      border-radius: 8px;
      height: 100%;
      object-fit: cover;
    }
  }

  .price-container {
    .payment-title {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #000000;
      margin-bottom: 8px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
    .payment-tag {
      .active {
        background: rgba(0, 171, 85, 0.08) !important;
        border-radius: 6px;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        color: #36b37e;
      }
      .failed {
        background: rgba(255, 86, 48, 0.08) !important;
        border-radius: 6px;
        font-weight: 700;
        border: none;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        color: #ff5630;
      }
    }
    .payment-price-container {
      margin-top: 10px;
      display: flex;
      align-items: center;
      .payment-price {
        .label {
          font-weight: 500;
          font-size: 14px;
          color: #7f8fa3;
          margin-bottom: 2px;
        }
        .price {
          font-size: 14px;
          color: #0ABAB5;
        }
      }
      .payment-quantity {
        border-left: 1px solid #7f8fa34d;
        padding-left: 20px;
        margin-left: 20px;
        .label {
          font-weight: 500;
          font-size: 14px;
          color: #7f8fa3;
          margin-bottom: 2px;
        }
        .quantity {
          font-size: 14px;
          color: #0ABAB5;
        }
      }
    }
  }
  .billing-container {
    margin-top: 16px;
    padding-top: 14px;
    border-top: 1px solid rgba(145, 158, 171, 0.24);
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #000000;
    span {
      color: #637381;
      margin-left: 5px;
    }
  }
  .date-row {
    margin-top: 15px;
    margin-bottom: 20px;
    .date-container {
      background: #f3f5f8;
      padding: 10px;
      .date-label {
        font-weight: 500;
        font-size: 14px;
        color: #7f8fa3;
      }
      .date-value {
        font-size: 14px;
        color: #0ABAB5;
      }
    }
  }
  .ant-list {
    .ant-col {
      height: 100%;
      .ant-list-item {
        height: 100%;
      }
    }
  }
  .action-buttons-container {
    display: flex;
    margin-top: 14px;
    align-items: center;
    justify-content: flex-end;
    .edit {
      border: none;
      border-radius: 8px;
      background: #0ABAB5;
      padding: 6px 16px;
      font-weight: 700;
      min-width: 86px;
      font-size: 13px;
      line-height: 22px;
      color: white;
      margin-left: 8px;
    }
    .resume-button {
      border: none;
      min-width: 86px;
      border-radius: 8px;
      background: #ff5630;
      padding: 6px 16px;
      font-weight: 700;
      font-size: 13px;
      line-height: 22px;
      color: white;
      margin-left: 8px;
    }
    .cancel {
      border: 1px solid rgba(145, 158, 171, 0.24);
      border-radius: 8px;
      background: white;
      padding: 6px 16px;
      font-weight: 700;
      font-size: 13px;
      line-height: 22px;
      color: #212b36;
      margin-left: 8px;
      height: 36px;
    }
  }
  .past-card {
    padding: 24px 24px 24px 24px;
    height: 100%;
    box-shadow: 0px 0px 2px rgba(145, 158, 171, 0.2),
      0px 12px 24px -4px rgba(145, 158, 171, 0.12);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .bv-container {
      .bv-title {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #212b36;
      }
      .bv-value {
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        color: #36b37e;
        margin-top: 4px;
      }
      .bv-value-1 {
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        color: #637381;
        margin-top: 4px;
      }
      .bv-value-2 {
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        color: #ff5630;
        margin-top: 4px;
      }
    }
    .pro-c {
      display: flex;
      margin-bottom: 16px;
      .pro-c-1 {
        width: 132px;
        height: 132px;
      }
      .pro-c-2 {
        width: calc(100% - 132px);
        padding-left: 16px;
        .date-container-n {
          .date-label-n {
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            color: #212b36;
            margin-bottom: 2px;
          }
          .date-value-n {
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            color: #ff5630;
          }
        }
      }
    }
  }
  @media (max-width: 1730px) {
    .subsc-list > div > div > div > div {
      width: 33.333% !important;
      max-width: 33.333% !important;
    }
  }
  @media (max-width: 1400px) {
    .subsc-list > div > div > div > div {
      width: 50% !important;
      max-width: 50% !important;
    }
  }

  @media (max-width: 1050px) {
    .subsc-list > div > div > div > div {
      width: 100% !important;
      max-width: 100% !important;
    }
  }
  @media (max-width: 900px) {
    .subsc-list > div > div > div > div {
      width: 50% !important;
      max-width: 50% !important;
    }
  }
  @media (max-width: 700px) {
    .subsc-list > div > div > div > div {
      width: 100% !important;
      max-width: 100% !important;
    }
  }
`;
